<template>
  <div class="top-page">
    <PageFrame>
      <template v-slot:mainPage>
        <div class="container">
          <Card>
            <template v-slot:contents>
              <h4>お知らせ</h4>
              <table class="table table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">掲載日</th>
                    <th scope="col"></th>
                    <th scope="col">お知らせ内容</th>
                  </tr>
                </thead>
                <tbody class="cursor-pointer">
                  <tr v-for="(row,index) in infolist" :key="row.no" @click.prevent.stop="infoDetail(index)">
                    <td class="align-middle">{{ row.viewDay }}</td>
                    <td class="align-middle"><div :class="'category-tag tag-' + row.categoryCode">{{ row.categoryName }}</div></td>
                    <td class="align-middle">{{ row.infoSubject }}</td>
                  </tr>
                </tbody>
              </table>
            </template>
          </Card>
        </div>
      </template>
    </PageFrame>
    <InfoModal @close="closeModal" v-if="modal" :Infolist='infolist[infoNumber]'></InfoModal>
  </div>
</template>
 
<script>
// @ is an alias to /src
import moment from 'moment';
import Api from '@/apis/api.js';
import PageFrame from '@/components/PageFrame.vue';
import Card from '@/components/common/Card.vue';
import InfoModal from '@/components/InfoModal.vue';
 
export default {
  components: {
    PageFrame,
    Card,
    InfoModal,
  },
  data() {
    return {
      infolist: null,
      modal: false,
    }
  },
  mounted(){
    this.getInfoList();
  },
  methods: {
    getInfoList() {
      Api.getInfoList()
        .then(response => {
          const list = [];
          response.data.infoList.forEach(element => {
            const el = {}
            el.no= element.infomationNo;
            el.viewDay = moment(element.displayStartDate).format('YYYY/MM/DD');
            el.categoryCode = element.categoryCode;
            el.categoryName = element.categoryName;
            el.infoSubject = element.subject;
            el.infoDetail = element.infomationDetail;
            list.push(el)
          });
          this.infolist = list;
        })
        .catch(error => {
          console.error(error);
        })
    },
    infoDetail(number) {
      this.infoNumber = number 
      this.modal = true
    },
    closeModal() {
      this.modal = false
    },
  }
}
</script>

<style scoped>
.category-tag {
  text-align: center!important;
  padding: 0.25rem!important;
  font-weight: bold;
  max-width: 150px;
  min-width: 40px;
}
.category-tag.tag-1 {
  background-color: #83B53F !important;
  color: #fff !important;
}
.category-tag.tag-2 {
  background-color: #6691CC !important;
  color: #fff !important;
}
.category-tag.tag-3 {
  background-color: #FDDB66 !important;
  color: #000 !important;
}
</style>